export default {
  methods: {
    async sendMedicalProcedureToClinics(profileId, procedureId, dateParam, event = null) {
      const medicalProcedurePayload = {
        profileId,
        medicalProcedures: [
          {
            id: procedureId,
            value: dateParam
          }
        ]
      };

      if (event) {
        medicalProcedurePayload.event = event;
      }

      await this.$http.put('/v3/medical-procedure/custom-fields/webhook', medicalProcedurePayload);
    }
  }
};
